var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"color":_vm.type,"timeout":_vm.timeout,"top":_vm.position==='top'?true:false,"bottom":_vm.position==='bottom'?true:false},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.message)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }